import { useCallback, useMemo } from 'react';

import { useGraphql } from '../graphql';

// The writes a daily record makes, each a single GraphQL mutation. They settle
// with nothing useful: the caller reloads the record afterwards.
export function useRecordChanges() {
  const graphql = useGraphql();

  // Only the fields given are changed; a field given as null is cleared.
  const save = useCallback(function({ date, input }) {
    return graphql({
      document: 'mutation Save($date: String!, $input: DailyRecordInput!) { saveDailyRecord(date: $date, input: $input) { date } }',
      variables: { date, input }
    });
  }, [ graphql ]);

  const saveEntries = useCallback(function({ date, entries }) {
    return graphql({
      document: 'mutation Entries($date: String!, $entries: [MedicationEntryInput!]!) { saveMedicationEntries(date: $date, entries: $entries) { date } }',
      variables: { date, entries }
    });
  }, [ graphql ]);

  const addMedication = useCallback(function({ name, doseMg }) {
    return graphql({
      document: 'mutation Add($name: String!, $doseMg: String) { addMedication(name: $name, doseMg: $doseMg) { id } }',
      variables: { name, doseMg }
    });
  }, [ graphql ]);

  const archiveMedication = useCallback(function(id) {
    return graphql({
      document: 'mutation Archive($id: ID!) { archiveMedication(id: $id) }',
      variables: { id }
    });
  }, [ graphql ]);

  return useMemo(function() {
    return { save, saveEntries, addMedication, archiveMedication };
  }, [ save, saveEntries, addMedication, archiveMedication ]);
}
